import { useRef, useState, useEffect } from 'react';
import { execSeatableSql } from './seatable.js';
import SectionHeader from './sectionheader.js';
import * as consts from '../consts.js';

function Leaders(props) {
    const [data, setData] = useState(null);

    useEffect(() => {
      async function fetchData() {
        const sql = `SELECT * FROM \`Leadership\` WHERE \`Disabled\` IS NOT TRUE AND \`Capability\` IN ('${props.capability}')`;
        setData(null);

        try {
          const rows = await execSeatableSql(sql);
          setData(rows && rows.results);
        } catch (err) {
          // setError(err);
        }
      }
      fetchData();
    }, [props.capability]);

    const scrollRef = useRef();
    const [page, setPage] = useState(0);
    const [totalPages, setTotalPages] = useState(0);
    const [showScrollControls, setShowScrollControls] = useState(false);
    const [hideLeftBtn, setHideLeftBtn] = useState(true);
    const [hideRightBtn, setHideRightBtn] = useState(false);

    const scroll = (direction) => {
        const { current } = scrollRef;
        const scrollAmount = 300;
        // if (direction === "left") current.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        // else current.scrollBy({ left: scrollAmount, behavior: "smooth" });
        if (direction === "left") current.scrollLeft -= scrollAmount
        else current.scrollLeft += scrollAmount;
        setTimeout(() => { setBtnStatus() }, 50);
    };

    const scrollToPage = (pageIndex) => {
        const { current } = scrollRef;
        current.scrollTo({ left: current.scrollWidth * pageIndex / totalPages, behavior: "smooth" });
        setPage(pageIndex);
        setTimeout(() => { setBtnStatus() }, 50);
    };

    const setBtnStatus = () => {
        const { current } = scrollRef;
        setHideLeftBtn(current.scrollLeft <= 0);
        setHideRightBtn(current.scrollLeft + current.clientWidth >= current.scrollWidth);
    }

    const handleScroll = () => {
        if (scrollRef && scrollRef.current) {
            const { scrollLeft, clientWidth, scrollWidth } = scrollRef.current;
            const progress = scrollLeft / (scrollWidth - clientWidth);

            const calcTotalPages = Math.ceil(scrollWidth / clientWidth);
            setTotalPages(calcTotalPages);

            setPage(Math.floor(progress * (calcTotalPages - 1)));
            setShowScrollControls(scrollWidth > clientWidth);
        }
    };

    useEffect(() => {
        if (scrollRef && scrollRef.current) {
            const container = scrollRef.current;
            container.addEventListener("scroll", handleScroll);
            setTimeout(() => { handleScroll() }, 50);
            return () => {
                container.removeEventListener("scroll", handleScroll);
            }
        }
    }, [data]);

    useEffect(() => {
        window.addEventListener('resize', handleScroll);
        return () => {
            window.removeEventListener('resize', handleScroll);
        }
    }, []);

    return <>
        {(data && (data.length > 0)) ? <>
            <div id="Leadership" className='nav-margin'>
                <SectionHeader capability={props.capability} section="Leadership"/>
            </div>
            {/*
            // infinite scrolling
            <div className="infinite-scroll-container pb-5 border-bottom border-secondary">
                <div className="infinite-scroll-track">
                    {[...data, ...data].map((row, i) => (
                        <div className="infinite-scroll-card">
                            <img className="w-100 h-100 img-fluid" src={row.src} alt={i} />
                            <div className="p-1 fs-5 lato-bold">Leader {i}<i className="ms-2 bi bi-linkedin"></i></div>
                            <div className="p-1 fs-6">Title</div>
                        </div>
                    ))}
                </div>
            </div>
            // scrolling with buttons on edges
            <div className="scroll-wrapper">
                <button className="scroll-btn left" onClick={() => scroll("left")}>◀</button>

                <div className="scroll-container" ref={scrollRef}>
                    {data.map((row, i) => (
                        <div className="scroll-card" key={i}>
                            <img className="w-100 h-100 img-fluid" src={row.src} alt={i} />
                            <div className="p-1 fs-5 lato-bold">Leader {i}<i className="ms-2 bi bi-linkedin"></i></div>
                            <div className="p-1 fs-6">Title</div>
                        </div>
                    ))}
                </div>
                
                <button className="scroll-btn right" onClick={() => scroll("right")}>▶</button>
            </div>
            */}
            <div>
                <div className="scroll-wrapper">
                    <div className="scroll-container" ref={scrollRef}>
                        {data.map((row, i) => (
                            <div className="scroll-card" key={i}>
                                <img style={{objectFit: "cover"}} src={row["fnMediaLink"]} alt={row.Name} onError={consts.handleImageError} />
                                <div className="d-flex flex-column">
                                    <div className="p-2 fs-5 lato-bold d-flex flex-row"><span>{row.Name}</span>
                                        {(row.Linkedin === '') ? '' : (
                                            <span className="ms-auto"><a target="_Blank" rel="noreferrer" href={row.Linkedin}><i className="ms-1 bi bi-linkedin"></i></a></span>
                                        )}
                                    </div>
                                    <div className="pb-2">
                                    {row.Capability.filter(e => e.display_value !== 'Home Page').map((item, index) => (
                                        <div key={index} className="px-2 fs-6 text-truncate" title={item.display_value}><small>{item.display_value}</small></div>
                                    ))}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
                
                <div className={`scroll-controls ${showScrollControls ? 'visible' : 'invisible'}`}>
                    <button className="scroll-btn" onClick={() => scroll("left")} disabled={hideLeftBtn} >◀</button>

                    <div className="page-dots">
                    {Array.from({ length: totalPages }).map((_, i) => (
                        <button key={i} className={`dot ${i === page ? "active" : ""}`} onClick={() => scrollToPage(i)} />
                    ))}
                    </div>

                    <button className="scroll-btn" onClick={() => scroll("right")} disabled={hideRightBtn} >▶</button>
                </div>
            </div>
        </> : ''}
    </>
}

export default Leaders;